// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  font-size: 8px;
  font-weight: 400;
  padding: 10px;
  background: #eaeaea;
  border-radius: 4px;
}

.checkedbox {
  font-size: 8px;
  font-weight: 400;
  padding: 10px;
  background: #797979;
  border-radius: 4px;
  color: white;
}
.stripePage {
  width: 40vw;
}
.creditCard {
  font-family: "Rubik";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 150%;
  margin-top: 40px;

  color: #323232;
}
.eventdetailss {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin: 0 5px;
}

.leftDiv label {
  margin-left: 0 !important;
}

.familyServiceDiv {
  opacity: 0.3;
}

.btn {
  font-size: 10px !important;
  border: none !important;
  padding: 10px !important;
  border-radius: 4px !important;
  background-color: #EAEAEA !important;
  color:#323232 !important;
}

.btnActive {
  color: white !important;
  background-color: #323232 !important;
  font-size: 10px !important;
  border: none !important;
  padding: 10px !important;
  border-radius: 4px;
}

.check-reg-inp {
  font-size: "8px !important";
  font-weight: "400 !important";
  margin-top: "10px !important";
  padding: "10px !important";
  background: "#EAEAEA !important";
  border-radius: "4px !important";
}

[type="checkbox"] {
  vertical-align: middle;
  accent-color: #ffffff;
  margin-right: 10px;
}

.reg-in-det {
  font-size: 12px;
  font-weight: 500;
  color:#424242;
}

.leftDiv {
  height: 92vh;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.leftDiv::-webkit-scrollbar {
  display: none;
}

.purchase-btn {
  background: #68ad3f;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 11px;
  border: none;
  color: white;
  width: 100%;
}
.purchase-btn:hover {
  background-color: #fbb040;
}

.purchase-btn-disabled {
  background: #68ad3f;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 11px;
  border: none;
  color: white;
  opacity: 0.3;
  width: 100%;
}

.reg-total {
  font-weight: 400;
  font-size: 30px;
  color: #68ad3f;
}

.reg-name-font {
  font-size: 18px;
  font-weight: 400;
  color:black;
}

.reg-name-font-opacity {
  font-size: 18px;
  font-weight: 400;
  opacity: 0.3;
}

.reg-amt {
  font-weight: 400;
  font-size: 16px;
  color: #ffff;
  background: #fbb040;
  padding: 1px 6px;
  text-align: center;
  border-radius: 4px;
}

.parentRegister .row > * {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.registerevents {
  width: 100%;
  border-bottom: 1.89372px solid rgba(140, 174, 120, 0.12);
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px;
  margin-bottom: 40px;
}

.registerevents1 {
  width: 100%;
}

.webeventslist {
  display: flex;
  align-items: center;
  width: 90% !important;
}

.eventimg {
  height: 75px;
  width: 75px;
}

.eventdetails {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin: 0 5px;
}


.eventmobile {
  display: none;
}

.eventmobilediv {
  display: flex;
  align-items: center;
  padding: 0px 20px 0px 20px;
}

.regBtn button {
  background-color: #eaeaea !important;
  color: #323232 !important;
  border: #eaeaea !important;
}

.buttonGroup label {
  margin-bottom: 10px;
  border-radius: 7px;
  margin-left: -3px;
}

label.btn {
  background-color: #eaeaea !important;
  color: #323232 !important;
  border: #eaeaea !important;
  text-align: left;
}

.labelButton:active {
  background-color: #323232 !important;
  color: #eaeaea !important;
  border: #eaeaea !important;
}

label.activeBtn {
  background-color: #797979 !important;
  color: #ffffff !important;
  border: #eaeaea !important;
}

input:checked .action {
  color: #fff !important;
}

.btn-group > .btn:active {
  color: #fff !important;
}

.input:checked {
  background-color: #f75a1b !important;
}

.dancerFeeBtn {
  background: #fbb040;
  border: none;
  border-radius: 4px;
  padding: 1px 6px;
  color: white;
}

.dancerNameHeading {
  font-size: 1.1em;
  text-transform: capitalize;
  font-weight: 500;
  color:black
}
form button {
  background: #68ad3f;
  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 11px;
  border: none;
  color: white;
  margin-top: 1em;
}

@media only screen and (min-width: 0px) and (max-width: 767px) {
  .leftDiv {
    height: auto;
  }
  .stripePage {
    width: auto !important;
  }
}
@media screen and (max-width: 1200px) {
  .chosegradee {
    border: 2px solid rgb(234, 234, 234) !important;
    padding: 5px;
    width: auto;
    display: flex;
    flex-wrap: wrap;
  }
}

.custom-checkbox {
  cursor: pointer;
}


.custom-checkbox label {
  top: 0;
  left: 0;
  height: 20px;
}

.custom-checkbox label::after {
  content: "";
  opacity: 0;
}

.custom-checkbox input[type="checkbox"]:checked + label::after {
  opacity: 1;
}

.reg-left-container {
  height: 75vh;
  overflow-y: scroll;
}
.right-calc-div{
   background: #fafafa;
    height: 96vh;
    overflow-y: scroll;
}

@media only screen and (min-width: 0px) and (max-width: 767px) {
  .mobile_eventName {
    max-width: 100%;
  }
  .reg-left-container {
    height: auto;
  }
  .right-calc-div{
     height: auto;
 }
}
`, "",{"version":3,"sources":["webpack://./src/Parent/Register-Events/style.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;EAEhB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,wDAAwD;EACxD,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;AACf;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB;AACF;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,+CAA+C;IAC/C,YAAY;IACZ,WAAW;IACX,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,MAAM;EACN,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;GACG,mBAAmB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;KACG,YAAY;CAChB;AACD","sourcesContent":[".checkbox {\n  font-size: 8px;\n  font-weight: 400;\n  padding: 10px;\n  background: #eaeaea;\n  border-radius: 4px;\n}\n\n.checkedbox {\n  font-size: 8px;\n  font-weight: 400;\n  padding: 10px;\n  background: #797979;\n  border-radius: 4px;\n  color: white;\n}\n.stripePage {\n  width: 40vw;\n}\n.creditCard {\n  font-family: \"Rubik\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 150%;\n  margin-top: 40px;\n\n  color: #323232;\n}\n.eventdetailss {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  margin: 0 5px;\n}\n\n.leftDiv label {\n  margin-left: 0 !important;\n}\n\n.familyServiceDiv {\n  opacity: 0.3;\n}\n\n.btn {\n  font-size: 10px !important;\n  border: none !important;\n  padding: 10px !important;\n  border-radius: 4px !important;\n  background-color: #EAEAEA !important;\n  color:#323232 !important;\n}\n\n.btnActive {\n  color: white !important;\n  background-color: #323232 !important;\n  font-size: 10px !important;\n  border: none !important;\n  padding: 10px !important;\n  border-radius: 4px;\n}\n\n.check-reg-inp {\n  font-size: \"8px !important\";\n  font-weight: \"400 !important\";\n  margin-top: \"10px !important\";\n  padding: \"10px !important\";\n  background: \"#EAEAEA !important\";\n  border-radius: \"4px !important\";\n}\n\n[type=\"checkbox\"] {\n  vertical-align: middle;\n  accent-color: #ffffff;\n  margin-right: 10px;\n}\n\n.reg-in-det {\n  font-size: 12px;\n  font-weight: 500;\n  color:#424242;\n}\n\n.leftDiv {\n  height: 92vh;\n  overflow: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.leftDiv::-webkit-scrollbar {\n  display: none;\n}\n\n.purchase-btn {\n  background: #68ad3f;\n  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 11px;\n  border: none;\n  color: white;\n  width: 100%;\n}\n.purchase-btn:hover {\n  background-color: #fbb040;\n}\n\n.purchase-btn-disabled {\n  background: #68ad3f;\n  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 11px;\n  border: none;\n  color: white;\n  opacity: 0.3;\n  width: 100%;\n}\n\n.reg-total {\n  font-weight: 400;\n  font-size: 30px;\n  color: #68ad3f;\n}\n\n.reg-name-font {\n  font-size: 18px;\n  font-weight: 400;\n  color:black;\n}\n\n.reg-name-font-opacity {\n  font-size: 18px;\n  font-weight: 400;\n  opacity: 0.3;\n}\n\n.reg-amt {\n  font-weight: 400;\n  font-size: 16px;\n  color: #ffff;\n  background: #fbb040;\n  padding: 1px 6px;\n  text-align: center;\n  border-radius: 4px;\n}\n\n.parentRegister .row > * {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.registerevents {\n  width: 100%;\n  border-bottom: 1.89372px solid rgba(140, 174, 120, 0.12);\n  background-color: white;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 20px;\n  margin-bottom: 40px;\n}\n\n.registerevents1 {\n  width: 100%;\n}\n\n.webeventslist {\n  display: flex;\n  align-items: center;\n  width: 90% !important;\n}\n\n.eventimg {\n  height: 75px;\n  width: 75px;\n}\n\n.eventdetails {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  margin: 0 5px;\n}\n\n\n.eventmobile {\n  display: none;\n}\n\n.eventmobilediv {\n  display: flex;\n  align-items: center;\n  padding: 0px 20px 0px 20px;\n}\n\n.regBtn button {\n  background-color: #eaeaea !important;\n  color: #323232 !important;\n  border: #eaeaea !important;\n}\n\n.buttonGroup label {\n  margin-bottom: 10px;\n  border-radius: 7px;\n  margin-left: -3px;\n}\n\nlabel.btn {\n  background-color: #eaeaea !important;\n  color: #323232 !important;\n  border: #eaeaea !important;\n  text-align: left;\n}\n\n.labelButton:active {\n  background-color: #323232 !important;\n  color: #eaeaea !important;\n  border: #eaeaea !important;\n}\n\nlabel.activeBtn {\n  background-color: #797979 !important;\n  color: #ffffff !important;\n  border: #eaeaea !important;\n}\n\ninput:checked .action {\n  color: #fff !important;\n}\n\n.btn-group > .btn:active {\n  color: #fff !important;\n}\n\n.input:checked {\n  background-color: #f75a1b !important;\n}\n\n.dancerFeeBtn {\n  background: #fbb040;\n  border: none;\n  border-radius: 4px;\n  padding: 1px 6px;\n  color: white;\n}\n\n.dancerNameHeading {\n  font-size: 1.1em;\n  text-transform: capitalize;\n  font-weight: 500;\n  color:black\n}\nform button {\n  background: #68ad3f;\n  box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 11px;\n  border: none;\n  color: white;\n  margin-top: 1em;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .leftDiv {\n    height: auto;\n  }\n  .stripePage {\n    width: auto !important;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .chosegradee {\n    border: 2px solid rgb(234, 234, 234) !important;\n    padding: 5px;\n    width: auto;\n    display: flex;\n    flex-wrap: wrap;\n  }\n}\n\n.custom-checkbox {\n  cursor: pointer;\n}\n\n\n.custom-checkbox label {\n  top: 0;\n  left: 0;\n  height: 20px;\n}\n\n.custom-checkbox label::after {\n  content: \"\";\n  opacity: 0;\n}\n\n.custom-checkbox input[type=\"checkbox\"]:checked + label::after {\n  opacity: 1;\n}\n\n.reg-left-container {\n  height: 75vh;\n  overflow-y: scroll;\n}\n.right-calc-div{\n   background: #fafafa;\n    height: 96vh;\n    overflow-y: scroll;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .mobile_eventName {\n    max-width: 100%;\n  }\n  .reg-left-container {\n    height: auto;\n  }\n  .right-calc-div{\n     height: auto;\n }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
